/**
 * Formatos do portal do cooperado (0094).
 *
 * As datas chegam em dois formatos, conforme a rota: `AAAA-MM-DD` (o banco) ou
 * `DD/MM/AAAA` (o formato do DER). Sem `new Date`: a string já é o dia civil, e
 * convertê-la em instante desliza o dia depois das 21 h.
 */
export function dataDoDia(v: string | null | undefined): string {
  if (!v) return '—';
  const iso = v.match(/^(\d{4})-(\d{2})-(\d{2})/);
  return iso ? `${iso[3]}/${iso[2]}/${iso[1]}` : v;
}

export const moeda = (v: number): string => v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
